<template>
	<div>
    <HeadNav
      :isShow="showHeadNavAll"
      @change="headNavChange"
      @showAllNav="headNavChangeStatus"
      :navIndex="headNavIndex">
    </HeadNav>
    <!-- <div class="banner-bg-content" :style="{'backgroundColor':themeColor}"></div> -->
    <div class="bodyWrap">
      <!-- banner -->
      <div class="banner pointer">
        <el-carousel  :interval="6000" @change="bannerChange">
          <el-carousel-item
            v-for="(item,index) in bannerList"
            :key="index">
            <img :src="item.image" @click="bannerClick(item)">
          </el-carousel-item>
        </el-carousel>
        <div class="index-customer-info">
          <div class="index-customer-user" v-if="!isLogin">
              <el-image :src="'tacitlyAvatra.png' | imagePath" fit="cover"></el-image>
              <div class="index-customer-user-info">
                  <span>Hi ~ 您好</span>
                  <div class="index-customer-login">
                    <a href="/login" >登录</a>
                    <a href="/register" >注册</a>
                  </div>
              </div>
          </div>
          <div class="index-customer-user" v-else>
              <el-image :src="avatar" fit="cover"></el-image>
              <div class="index-customer-user-info">
                  <span :title="nickname">{{nickname}}</span>
                  <span v-if="company_name" :title="company_name">{{company_name}}</span>
              </div>
          </div>
          <div class="index-delivery-search-wrap" :class="isFocus ? 'focus' : ''">
            <el-tooltip class="item" effect="dark" content="输入合同单号、发货单号或客户PO号查询" placement="top">
              <input 
                v-model="deliveryNo" 
                @focus="toggleFocus" 
                @blur="toggleFocus" 
                class="index-delivery-search" 
                size="small" 
                placeholder="物流信息查询" 
                clearable
                @keyup.enter="deliverySearch"
              />
            </el-tooltip>
            <el-button type="primary" class="index-delivery-search-btn" size="small" icon="el-icon-search" circle @click="deliverySearch"></el-button>
          </div>
           <div class="index-news-wrap" v-if="article_cats.length">
            <div class="index-news-nav-wrap">
              <ul class="index-news-nav">
                <li class="index-news-nav-item" :class="activeIndex == index ? 'active' : ''"  v-for="(item,index) in article_cats" :key="index" v-if="index < 3" @click="activeIndex = index">{{item.name}}</li>
              </ul>
              <a href="/information" class="index-news-more">更多&gt;&gt;</a>
            </div>
            <ul class="index-news" v-for="(item,index) in current_news_list" :key="index">
              <li class="index-news-item">
                <a :href="`informationDetail?article_id=${item.article_id}`" :title="item.title">
                  {{item.title}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 品牌 -->
      <div class="index-brand-wrap" v-show="brandList.length">
        <ul class="index-brand">
          <li v-for="(item, index) in brandList" v-show="index<5" :key="index">
             <a :href= "`brandDetail?brand_id=${item.brand_id}` | hrefFormat" target="_blank">
              <el-image :src="item.logo" fit="contain">
                <div slot="error" class="image-slot">
                  <el-image :src="'logo.png' | imagePath"></el-image>
                </div>
              </el-image>
                <span>了解更多</span>
              </a>
          </li>
        </ul>
        <a :href="'brand' | hrefFormat" class="index-brand-more">
          <img :src="'icon_right_white.png' | imagePath" />
        </a>
      </div>
      <!-- 活动产品 -->
      <div class="index-time-limit-list">
        <div class="index-time-limit" v-for="(item,index) in activities" :key="index">
          <!-- 列表类型：1秒杀 2促销 3预售 4组合 5团购 -->
          <a class="index-time-limit-left"
            target="_blank"
            :href="'goodsActivity?status='+item.type | hrefFormat"
           >
            <el-image :src="item.pc_image" fit="cover" class="index-time-limit-left-picture pointer">
              <div slot="error" class="image-slot">
                <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
              </div>
            </el-image>
          </a>
          <div class="index-time-limit-right">
            <div class="index-time-limit-item" v-for="(val,cindex) in item.children" :key="cindex">
              <img :src="val.status == 1 ? 'timeStatus1.png' : (val.status == 2 ? 'timeStatus3.png' : 'timeStatus2.png') | imagePath" class="index-time-limit-item-status"/>
              <a :href="'goodsActivityDetail?activity_id='+val.activity_id | hrefFormat" target="_blank">
                <el-image :src="val.thumbnail" fit="cover" class="index-time-limit-item-picture pointer">
                  <div slot="error" class="image-slot">
                    <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
                  </div>
                </el-image>
              </a>
              <a :href="'goodsActivityDetail?activity_id='+val.activity_id | hrefFormat" target="_blank" class="index-time-limit-item-title">
                {{val.title}}
              </a>
              <div class="index-time-limit-item-price" v-show="isLogin">
                <span style="color: #999999;font-size: 14px;">活动价：</span><em>￥</em>{{val.prom_price | productPrice}}
              </div>
              <BtnAuth></BtnAuth>
            </div>
          </div>
        </div>
      </div>
      <!-- 楼层锚链接导航栏  -->
      <ul class="floor-nav" ref="floorNav" :class="floorVisible ? 'show' : ''">
        <li class="floor-item" :class="archorIndex == index ? 'active' : 0" @click="goAnchor(index)" v-for="(item,index) in recommend_cats" :key="index">
          <span>{{`${index+1}F`}}</span>
          <span>{{item.name}}</span>
        </li>
      </ul>
      <!-- 分类产品 -->
      <div class="index-goods-type" :ref="`floorArchor`" :id="`floorArchor-${parentIndex}`" v-for="(parentItem,parentIndex) in recommend_cats" :key="parentIndex">
        <div class="index-goods-type-left">
          <a :href="`goodsList?cat_id=${parentItem.cat_id}`">
            <el-image :src="parentItem.pc_image" fit="cover" class="index-goods-type-left-picture">
              <div slot="error" class="image-slot">
                <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
              </div>
            </el-image>
          </a>
        </div>
        <div class="index-goods-type-center">
          <ul class="index-goods-type-center-nav">
            <li v-for="(val,childIndex) in parentItem.children"
            :key="childIndex"
            class="pointer"
            @mouseenter="goodsTypeClick(parentIndex,childIndex)"
            :class="parentItem.current==childIndex ? 'active':''"
            >
              {{val.name}}
            </li>
          </ul>
          <div class="index-goods-type-center-list">
            <template v-for="(child, childIndex) in parentItem.children">
              <div v-show="parentItem.current == childIndex"
                   v-for="(item, index) in child.children.slice(0, 6)"
                   :key="childIndex + '-' + index"
                   class="index-goods-type-center-item">
                <a :href="'goodsDetail?goods_id='+item.goods_id | hrefFormat" target="_blank">
                  <el-image :src="item.thumbnail" fit="cover" :lazy="childIndex !== 0" class="index-goods-type-center-picture">
                    <div slot="error" class="image-slot">
                      <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
                    </div>
                  </el-image>
                </a>
                <a :href="'goodsDetail?goods_id='+item.goods_id | hrefFormat" target="_blank"
                  class="index-goods-type-center-name">
                  {{item.title}}
                </a>
                <div class="index-goods-type-center-price" v-if="item.price_type == 1 && isLogin">
                  <span><strong><em>￥</em> {{item.price | productPrice}}</strong></span>
                </div>
                <div class="index-goods-type-center-price" v-else-if="item.price_type == 2 && isLogin">
                  <span>活动价：<strong><em>￥</em> {{item.prom_price | productPrice}}</strong></span>
                </div>
                <div class="index-goods-type-center-price" v-else-if="item.price_type == 3 && isLogin">
                  <span>协议价：<strong><em>￥</em> {{item.agreement_price | productPrice}}</strong></span>
                  <span>平台价：<del><em>￥</em> {{item.price | productPrice}}</del></span>
                </div>
                <BtnAuth></BtnAuth>
              </div>
            </template>
          </div>
        </div>
        <div class="index-goods-type-right">
          <div class="index-goods-type-right-top">
            <span>销量排行榜</span>
            <ul class="index-goods-type-right-nav" v-if="parentItem.sort && parentItem.sort.length > 6">
              <li v-for="(item,sindex) in parentItem.sort.length > 6 ? 2 : 1"
              :key="sindex"
              @mouseover="sortClick(parentIndex,sindex)"
              :class="parentItem.sortCurrent == sindex ? 'active':''"></li>
            </ul>
          </div>
          <div class="index-goods-type-right-list">
            <div v-if="(parentItem.sortCurrent == 0 && index < 6) || (parentItem.sortCurrent == 1 && index >= 6)" class="index-goods-type-right-item" v-for="(item,index) in parentItem.sort" :key="index">
              <img :src="index == 0 ? 'icon_first.png' : (index == 1 ? 'icon_second.png' : 'icon_third.png') | imagePath" class="index-goods-type-right-rank" v-if="index == 0 || index == 1 || index == 2"/>
              <span class="index-goods-type-right-rank-num" v-else>{{index+1}}</span>
              <a :href="'goodsDetail?goods_id='+item.goods_id | hrefFormat" target="_blank"  :title="item.title">
                <el-image :src="item.thumbnail" fit="cover" class="index-goods-type-right-picture">
                  <div slot="error" class="image-slot">
                    <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
                  </div>
                </el-image>
              </a>
              <div class="index-goods-type-right-item-info">
                <a :href="'goodsDetail?goods_id='+item.goods_id | hrefFormat" target="_blank"  :title="item.title">{{item.title}}</a>
                <strong v-show="isLogin">￥ {{(item.price_type == 1 ? item.price : (item.price_type == 3 ? item.agreement_price : item.prom_price)) | productPrice}}</strong>
                <BtnAuth></BtnAuth>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 侧边栏 -->
      <SideBar></SideBar>
      <!-- 登录框 -->
      <!-- <DialogLogin></DialogLogin> -->
      <!-- banner图文弹框 -->
      <el-dialog title="" :visible.sync="dialogTableVisible">
        <div v-html="bannerContent" class="bannerContent"></div>
      </el-dialog>
      <express-check
        ref="expressCheck"
        :visible.sync="expireVisible"
      />
    </div>
	</div>
</template>

<script>
import HeadNav from "@/components/HeadNav";
import SideBar from "@/components/SideBar";
import DialogLogin from "@/components/DialogLogin";
import BtnAuth from "@/components/BtnAuth";
import ExpressCheck from "@/components/ExpressCheck";
export default {
  name: "index",
  data() {
    return {
      isLogin: this.$.user.userLogin(),
      showHeadNavAll: true,
      headNavIndex: 0,
      bannerList: [],
      brandList: [], //推荐品牌
      exchange_goods: [], //积分商品
      recommend_cats: [], //推荐分类
      activities: [], //活动产品推荐
      dialogTableVisible: false,
      bannerContent: "",
      bannerIndex:0,
      themeColor:'rgb(243,243,245)',
      archorIndex:-1,
      floorVisible:false,
      article_cats:[],
      activeIndex:0,
      deliveryNo:"",
      avatar:"",
      nickname:"",
      company_name:"",
      expireVisible:false,
      isFocus:false,
    };
  },
  computed:{
    current_news_list(){
      const { article_cats,activeIndex  } =  this
      return article_cats[activeIndex] && article_cats[activeIndex].children &&article_cats[activeIndex].children.length ? article_cats[activeIndex].children : []
    }
  },
  methods: {
    headNavChangeStatus(e) {
      this.showHeadNavAll = e.isShow;
    },
    headNavChange(e) {
      this.headNavIndex = e.index;
    },
    // 获取接口数据
    getData() {
      return this.$.http.post("index/pc").then((res) => {
        res = res.data;
        // banner
        this.bannerList = res.banners;
        // this.setThemeColor()
        this.brandList = res.recommend_brands;
        this.activities = res.activities;
        // 推荐分类
        this.recommend_cats = res.recommend_cats;
        if (window.__PRERENDER_INJECTED) console.log(`[Prerender] ${new Date().toLocaleTimeString()} index/pc 返回，开始发起子分类请求`)

        const stats = { ok: 0, fail: 0 }
        const phase1Fns = []
        const phase2Fns = []

        res.recommend_cats.forEach((item, index) => {
          this.$set(item, 'sort', []); //销量排行
          this.$set(item, 'sortCurrent', 0); //销量排行默认第0页
          this.$set(item, 'current', 0); //当前选中
          item.children.forEach((val, cindex) => {
            this.$set(val, 'children', []);
            const label = cindex === 0 ? `phase1[cat${index}-${cindex}]` : `phase2[cat${index}-${cindex}]`
            const fn = () => this.siftGoods(val.cat_id, index, cindex).then(
              () => { stats.ok++ },
              e => {
                stats.fail++
                if (window.__PRERENDER_INJECTED) {
                  const info = e && e.status !== undefined ? `HTTP ${e.status} ${e.statusText || ''}` : JSON.stringify(e)
                  console.error(`[Prerender] 请求失败 ${label}: ${info}`)
                }
              }
            )
            if (cindex === 0) phase1Fns.push(fn)
            else phase2Fns.push(fn)
          });
        });

        // 限流并发：最多 limit 个任务同时执行，避免并发过多导致服务端断连
        const runWithConcurrency = (fns, limit) => {
          let i = 0
          const runOne = () => {
            if (i >= fns.length) return Promise.resolve()
            return fns[i++]().then(runOne, runOne)
          }
          return Promise.all(Array.from({ length: Math.min(limit, fns.length) }, runOne))
        }

        return runWithConcurrency(phase1Fns, 6).then(() => {
          if (window.__PRERENDER_INJECTED) console.log(`[Prerender] ${new Date().toLocaleTimeString()} phase1（${phase1Fns.length}个）完成，开始 phase2（${phase2Fns.length}个）`)
          return runWithConcurrency(phase2Fns, 8)
        }).then(() => {
          if (window.__PRERENDER_INJECTED) console.log(`[Prerender] 子分类请求完成：成功 ${stats.ok} 个，失败 ${stats.fail} 个`)
        });
      });
    },
    goodsTypeClick(parentIndex, childIndex) {
      this.$set(this.recommend_cats[parentIndex], "current", childIndex);
      // v-show 切换后 el-image lazy 不会自动感知，手动触发 scroll 让它重新检查可见图片
      this.$nextTick(() => window.dispatchEvent(new Event('scroll')));
    },
    siftGoods(cat_id, parentIndex, childIndex) {
      const isPrerender = window.__PRERENDER_INJECTED
      const log = isPrerender ? (...args) => console.log(...args) : () => {}

      let p1;
      if (cat_id == 0) {
        //精选推荐
        const params = { cat_id: this.recommend_cats[parentIndex].cat_id }
        log(`[Prerender] → goods/recommendList`, JSON.stringify(params), `(cat${parentIndex}-${childIndex})`)
        p1 = this.$.http
          .post("goods/recommendList", params, false, false, false)
          .then((res) => {
            log(`[Prerender] ✓ goods/recommendList (cat${parentIndex}-${childIndex}) 返回 ${res.data ? res.data.length : 0} 条`)
            this.$set(this.recommend_cats[parentIndex].children[childIndex], 'children', res.data);
          });
      } else {
        // 分类商品
        const params = { cat_id, is_filter: false }
        log(`[Prerender] → goods/search`, JSON.stringify(params), `(cat${parentIndex}-${childIndex})`)
        p1 = this.$.http
          .post("goods/search", params, false, false, false)
          .then((res) => {
            log(`[Prerender] ✓ goods/search cat_id=${cat_id} (cat${parentIndex}-${childIndex}) 返回 ${res.data && res.data.list ? res.data.list.length : 0} 条`)
            this.$set(this.recommend_cats[parentIndex].children[childIndex], 'children', res.data.list);
          });
      }

      // 销量排行只在每个主分类的第一个子分类时请求，避免同一主分类重复发
      if (childIndex === 0) {
        const sortParams = { cat_id: this.recommend_cats[parentIndex].cat_id, sort_type: 2, is_filter: false }
        log(`[Prerender] → goods/search(排行)`, JSON.stringify(sortParams), `(cat${parentIndex})`)
        const p2 = this.$.http
          .post("goods/search", sortParams, false, false, false)
          .then((res) => {
            log(`[Prerender] ✓ goods/search 排行 cat${parentIndex} 返回 ${res.data && res.data.list ? res.data.list.length : 0} 条`)
            this.$set(this.recommend_cats[parentIndex], 'sort', res.data.list);
            this.$set(this.recommend_cats[parentIndex], 'sortCurrent', 0);
          });
        return Promise.all([p1, p2]);
      }

      return p1;
    },
    /**
     * 销量排行
     */
    sortClick(parentIndex, index) {
      this.$set(this.recommend_cats[parentIndex], "sortCurrent", index);
    },
    // banner跳转  类型：1:无连接 2:超链接 3:图文H5 4:产品 5:分类 6:品牌
    bannerClick(item) {
      if (item.type == 1) {
        return;
      } else if (item.type == 2) {
        window.open(item.url);
      } else if (item.type == 3) {
        this.dialogTableVisible = true;
        this.bannerContent = item.content;
        // window.open(process.env.NODE_HOST + 'api/user/basic/agreement/h5/'+item.entity_id)
      } else if (item.type == 4) {
        window.open(
          process.env.NODE_HOST + "goodsDetail?goods_id=" + item.entity_id
        );
      } else if (item.type == 5) {
        window.open(
          process.env.NODE_HOST + "goodsList?cat_id=" + item.entity_id
        );
      } else if (item.type == 6) {
        window.open(
          process.env.NODE_HOST + "brandDetail?brand_id=" + item.entity_id
        );
      }
    },
    bannerChange(val) {
      this.bannerIndex = val
      // this.setThemeColor()
    },
    // setThemeColor(){
    //   const { bannerIndex,bannerList } = this
    //   const { image } = bannerList[bannerIndex]
    //   this.$.image.pickThemeColor(image).then(res => {
    //     this.themeColor = res
    //   })
    // },
    goAnchor(index) {
      const anchor = this.$el.querySelector(`#floorArchor-${index}`)
      const searchHeight = 96
      this.archorIndex = index
      document.documentElement.scrollTop = anchor.offsetTop - searchHeight
    },
    windowScroll(){
      if (!this.$refs['floorArchor']) return
      this.archorIndex = -1
      this.$refs['floorArchor'].map((item,index)=>{
        if(item.getBoundingClientRect().top < 400){
          this.archorIndex = index
          this.floorVisible = true
          this.windowResize()
        }else{
          if(index == 0){
            this.floorVisible = false
          }
        }
      })
    },
    windowResize(){
      const width = document.documentElement.clientWidth
      if(width >= 1500){
         this.$refs['floorNav'].style.left = (width - 1200)/2 - 150 + 'px'
        this.floorVisible = true
      }
      else if(width > 1380 && width < 1500){
        this.$refs['floorNav'].style.left = 0
      }
      else{
        this.floorVisible = false
      }
    },
    getArticleList(){
      return this.$.http.post('article/index').then(res=>{
        const { categories,banners,newest_articles,recommend_cats } = res.data;
        // this.categories = categories;
        // this.banners = banners;
        this.newest_articles = newest_articles;
        this.article_cats = recommend_cats;
      })
    },
    getPersonDetail() {
      this.$.http
        .post("center/detail", "", "", false, false, false)
        .then((res) => {
          res = res.data;
          this.avatar = res.avatar;
          this.nickname = res.nickname;
          this.company_name = res.company_name;
          this.$.storage.setItem("changwei_role_type", res.role_type);
        });
    },
    loginChange(){
      const isLogin = (this.isLogin = this.$.user.userLogin());
      if (isLogin) {
        this.getPersonDetail();
      }
      // 个人信息修改时监听
      this.$.notification.on("personInfoChange", (res) => {
        this.getPersonDetail();
      });
      // 登录状态监听
      this.$.notification.on("login", (bo) => {
        this.isLogin = bo == 1;
        this.getPersonDetail();
      });
    },
    deliverySearch(){
      const { deliveryNo } = this
      this.expireVisible = true
      this.$refs.expressCheck.send({deliveryNo})
    },
    toggleFocus(){
      this.isFocus = !this.isFocus
    },
  },
  mounted() {
    this.loginChange();
    // 首页数据全部加载完成后触发预渲染，确保两轮串联请求都已返回
    Promise.all([this.getData(), this.getArticleList()]).then(() => {
      if (window.__PRERENDER_INJECTED) console.log(`[Prerender] ${new Date().toLocaleTimeString()} 所有数据完毕，触发 prerender-trigger`)
      document.dispatchEvent(new Event('prerender-trigger'))
    }).catch((err) => {
      if (window.__PRERENDER_INJECTED) {
        const info = err && err.status !== undefined
          ? `HTTP ${err.status} ${err.statusText || ''}`
          : JSON.stringify(err)
        console.error(`[Prerender] ${new Date().toLocaleTimeString()} 数据加载出错，仍触发 prerender-trigger。错误：${info}`)
      }
      document.dispatchEvent(new Event('prerender-trigger'))
    });
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.windowScroll)
      window.addEventListener('resize',this.windowScroll)
    })
  },
  components: {
    HeadNav,
    SideBar,
    DialogLogin,
    BtnAuth,
    ExpressCheck
  },
  beforeCreate() {
    if(document.querySelector(".bodyCenter")){
      if(document
      .querySelector(".bodyCenter")){
        document
        .querySelector(".bodyCenter")
        .setAttribute("style", "background:#ffffff;");
      }
    }
  },
  destroyed(){
    window.removeEventListener('scroll',this.windowScroll)
    window.removeEventListener('resize',this.windowScroll)
  }
};
</script>

<style>
@import url("../assets/css/Index.css");
.suspend {
  background-color: #383838;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 44px;
  z-index: 9;
  max-height: 900px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.suspend-nav {
  position: relative;
}
.suspend-nav img {
  display: block;
  margin: auto;
  cursor: pointer;
  position: relative;
  z-index: 10;
}
.suspend-car {
  margin: 20px 0;
  border-top: 1px solid #555;
  border-bottom: 1px solid #555;
  padding: 10px 0;
}
.suspend-car p {
  color: #ffffff;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  margin: 10px 0;
}
.suspend-car-num {
  display: block;
  margin: 0 auto;
  background-color: #e60012;
  color: #ffffff;
  border-radius: 6px;
  width: 30px;
  line-height: 20px;
  text-align: center;
}
.suspend-news {
  margin-bottom: 150px;
}
.suspend-nav-service {
  margin-bottom: 40px;
}

.suspend-user-hover {
  position: absolute;
  z-index: 9;
  left: 200px;
  top: -20px;
  background-color: #ffffff;
  text-align: center;
  line-height: 50px;
  width: 100px;
  font-size: 14px;
}
.suspend-user:hover .suspend-user-hover {
  left: -100px;
  transition: all 0.3s ease-in-out;
}
.suspend-car:hover {
  background-color: #e60012;
}
.suspend-news-hover,
.suspend-discount-hover,
.suspend-collect-hover,
.suspend-footprint-hover,
.suspend-phone-hover,
.suspend-customer-hover,
.suspend-top-hover {
  background-color: rgb(0, 0, 0, 0.8);
  color: #ffffff;
  line-height: 30px;
  width: 100px;
  text-align: center;
  position: absolute;
  z-index: 9;
  left: 200px;
  top: -10px;
}
.suspend-news:hover .suspend-news-hover,
.suspend-discount:hover .suspend-discount-hover,
.suspend-collect:hover .suspend-collect-hover,
.suspend-footprint:hover .suspend-footprint-hover,
.suspend-phone:hover .suspend-phone-hover,
.suspend-customer:hover .suspend-customer-hover,
.suspend-top:hover .suspend-top-hover {
  left: -100px;
  transition: all 0.6s ease-in-out;
}

.suspend-load-hover {
  background-color: #ffffff;
  width: 160px;
  text-align: center;
  font-size: 14px;
  position: absolute;
  z-index: 9;
  left: 200px;
  top: -10px;
  line-height: 30px;
}
.suspend-load-hover img {
  width: 120px;
  height: 120px;
  margin: 10px auto;
  display: block;
}
.suspend-load:hover .suspend-load-hover {
  left: -160px;
  transition: all 0.6s ease-in-out;
}
.index-brand .image-slot img {
  width: 104px;
  height: 33px;
  margin: 88px 53px;
}
.index-brand-wrap {
  overflow: hidden;
  display: flex;
  align-items: center;
}
.index-brand-more {
  /* float: left; */
  text-align: center;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  font-size: 20px;
  background-color: #e60012;
  height: 200px;
  border-radius: 3px;
  width: 20px;
}
.index-brand-more img {
  width: 9px;
  height: 16px;
}
.bannerContent img {
  max-width: 100%;
}
.el-carousel__container {
  z-index: 2;
}
.banner.pointer {
  position: relative;
}
.banner.pointer .el-carousel__arrow--left{
  left: 250px;
}
.banner.pointer .el-carousel__arrow{
  background-color: rgba(31,45,61,0.3);
}
.banner-bg-content {
  position: absolute;
  width: 100%;
  height: 517px;
  z-index: 1;
  overflow: hidden;
  transition: background 1s;
}
.floor-nav{
  position: fixed;
  left:0;
  top: 50%;
  transform: translateY(-50%) scale(0);
  left: 0;
  z-index: 7;
  background: #fff;
  border: 1px solid #ddd;
  overflow: hidden;
  border-radius: 5px;
  transition: transform 0.3s;
}
.floor-nav.show{
  transform: translateY(-50%) scale(1);
}
.floor-nav>li.floor-item{
  width: 60px;
  min-height: 30px;
  padding: 5px 15px;
  line-height: 15px;
  font-size: 12px;
  color: #999;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}
.floor-nav>li.floor-item:last-child{
  border-bottom: 0;
}
.floor-nav>li.floor-item>span {
  display: block;
  /* height: 15px; */
  /* width: 50px; */
  overflow: hidden;
}
li.floor-item:hover,
li.floor-item.active{
  background: #E60012;
  color: #fff;
}
.index-customer-info{
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255,255,255,0.8);
  z-index: 2;
  width: 240px;
  overflow: hidden;
}
/* .banner.pointer .el-carousel__arrow--right{
  right: 250px;
} */
.index-customer-user{
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.index-customer-user > .el-image {
  display: block;
  width: 60px;
  height: 60px;
  padding: 8px;
  flex-shrink: 0;
}
.index-customer-user img{
  border-radius: 50% !important;
}
.index-customer-user-info{
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between
}
.index-customer-user-info span{
  display: block;
}
.index-news-nav{
  display: flex;
}
.index-news-nav-item{
  padding:4px 5px;
}
.index-news-nav-item.active{
  color: #D70B17;
  font-weight: 700;
  border-bottom: 2px solid #D70B17;
}
.index-news-nav-wrap{
  display: flex;
  padding:5px 10px;
  align-items: center;
}
.index-news-more{
  margin-left: auto;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  text-decoration: none;
}
.index-customer-user-info  a {
  color: #3366CC;
  font-size: 14px;
  text-decoration: none;
}
.index-customer-user-info span:last-child{
  margin-top: 5px;
}
.index-customer-user-info span{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
li.index-news-item {
  padding: 0 10px;
}
li.index-news-item > a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  text-decoration: none;
  color: #333;
  font-weight: 400;
  font-size: 12px;
  line-height: 25px;
}
.index-customer-login > a:first-of-type::after {
  content: '';
  position: absolute;
  top: 2px;
  bottom: 2px;
  right: -7px;
  width: 1px;
  background-color: #3366CC;
}
.index-customer-login > a{
  position: relative;
}
.index-customer-login{
  margin-top: 10px;
  position: relative;
  width: 70px;
  display: flex;
  justify-content: space-between;
}
.index-delivery-search{
  border-radius: 30px;
  margin-right: 5px;
  height: 33px;
  padding:0 20px;
  width:100%
}
.index-delivery-search input{
  border-radius: 30px;
  background: #fff;
}
.index-delivery-search-wrap{
  display: flex;
  padding: 0 10px;
  margin: 10px 0;
  align-items: center;
  height: 35px;
}
.index-news-wrap{
  user-select: none;
}
.index-delivery-search-wrap.focus .index-delivery-search-btn{
  display: none;
}
/* .index-delivery-search-wrap .el-input-group__append{
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
  overflow: hidden;
}
.index-delivery-search-wrap .el-input-group__append .el-button{
  padding: 12px 14px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
} */
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue